import { Component, Input, OnInit } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule
];
@Component({
  selector: 'eq-textInput',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
})
export class TextInputComponent extends EqBaseComponent implements OnInit{
  clearFilter(event: any){
    event.preventDefault()
    this.form.get(this.name)?.reset();
  }
}
